const initialState = {
	isLoading: false,
	loginChecked: {
		admin: false,
		customer: false
	},
	admin: null,
	customer: null,
	guest: null,
	loginTokenLoading: false,
	loginTokens: {},
	loginTypeAttempted: null,
	errors: {},
	loginAttempts: {},
	maxLoginsReached: {},
	passwordRequestSuccess: false,
	passwordRequestErrors: {},
	passwordUpdateSuccess: false,
	passwordUpdateErrors: {},
	accountCreateSuccess: false,
	accountUpdateSuccess: false
};

const userTypeMap = {
	customer: "customer",
	guest: "guest",
	admin: "user"
};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//  LOGIN TOKEN
		// ===================================
		case "USER_LOGIN_TOKEN_LOADING":
			return {
				...state,
				loginTokenLoading: true
			};

		case "USER_LOGIN_TOKEN_SET":
			return {
				...state,
				loginTokenLoading: false,
				loginTokens: {
					...state.loginTokens,
					[action.userType]: action.token
				},
				maxLoginsReached: {
					...state.maxLoginsReached,
					[action.userType]: action.maxLoginsReached
				}
			};

		case "UPDATE_USER_MAX_LOGIN":
			return {
				...state,
				maxLoginsReached: {
					...state.maxLoginsReached,
					[action.userType]: action.maxLoginsReached
				}
			};

		// ===================================
		//  LOGIN
		// ===================================
		case "USER_LOGIN_LOADING":
			return {
				...state,
				isLoading: true,
				errors: {},
				loginTypeAttempted: action.userType
			};

		case "USER_LOGIN_ERROR":
			return {
				...state,
				errors: action.err,
				isLoading: false
			};

		case "USER_LOGIN_SUCCESS":
			const { token } = action.payload;
			const userData = action.payload[userTypeMap[action.userType]];

			const newState = {
				...state,
				isLoading: false,
				// guest: initialState.guest,
				[action.userType]: {
					user: { ...userData },
					token: token
				},
				loginTokens: {
					...state.loginTokens,
					[action.userType]: ""
				},
				maxLoginsReached: {
					...state.maxLoginsReached,
					[action.userType]: false
				},
				errors: {}
			};

			return newState;

		case "USER_LOGOUT":
			return {
				...state,
				loginTypeAttempted: null,
				[action.userType]: null
			};

		case "CLEAR_ERRORS":
			return {
				...state,
				loginTypeAttempted: null,
				errors: {}
			};

		case "EXPIRY_CHECKED":
			return {
				...state,
				loginChecked: {
					...state.loginChecked,
					[action.userType]: true
				}
			};

		case "USER_TOKEN_UPDATE":
			return {
				...state,
				[action.userType]: {
					...state[action.userType],
					token: action.token
				}
			};

		// ===================================
		//  PASSWORD REQUEST
		// ===================================
		case "PASSWORD_REQUEST_LOADING":
			return {
				...state,
				passwordRequestSuccess: initialState.passwordRequestSuccess,
				passwordRequestErrors: initialState.passwordRequestErrors,
				isLoading: true
			};

		case "PASSWORD_REQUEST_ERROR":
			return {
				...state,
				passwordRequestErrors: action.err,
				isLoading: false
			};

		case "PASSWORD_REQUEST_SUCCESS":
			return {
				...state,
				passwordRequestSuccess: true,
				isLoading: false
			};

		// ===================================
		//  PASSWORD REQUESTe
		// ===================================
		case "CREATE_ACCOUNT_LOADING":
			return {
				...state,
				accountCreateSuccess: initialState.accountCreateSuccess,
				accountUpdateSuccess: initialState.accountUpdateSuccess,
				errors: initialState.errors,
				isLoading: true
			};

		case "CREATE_ACCOUNT_ERROR":
			return {
				...state,
				errors: action.err,
				isLoading: false
			};

		case "CREATE_ACCOUNT_SUCCESS":
			return {
				...state,
				accountCreateSuccess: true,
				isLoading: false
			};

		// ===================================
		//  PASSWORD UPDATE
		// ===================================
		case "PASSWORD_UPDATE_LOADING":
			return {
				...state,
				passwordUpdateSuccess: initialState.passwordUpdateSuccess,
				passwordUpdateErrors: initialState.passwordUpdateErrors,
				isLoading: true
			};

		case "PASSWORD_UPDATE_ERROR":
			return {
				...state,
				passwordUpdateErrors: action.err,
				isLoading: false
			};

		case "PASSWORD_UPDATE_SUCCESS":
			return {
				...state,
				passwordUpdateSuccess: true,
				isLoading: false
			};

		case "PASSWORD_UPDATE_CLEAR_STATE":
			return {
				...state,
				passwordUpdateSuccess: initialState.passwordRequestSuccess,
				passwordUpdateErrors: initialState.passwordUpdateErrors
			};

		// ===================================
		//  UPDATE ACCOUNT
		// ===================================
		case "UPDATE_CUSTOMER_ACCOUNT_SUCCESS":
			return {
				...state,
				customer: {
					...state.customer,
					user: action.customer
				},
				accountUpdateSuccess: true,
				isLoading: false
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/user.js